export default __webpack_public_path__ + "static/media/NIB Bank Cheque.1b26ab2b.jpg";